function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.708 0H2.292C1.028 0 0 1.028 0 2.292V17.708C0 18.972 1.028 20 2.292 20H17.708C18.972 20 20 18.972 20 17.708V2.292C20 1.028 18.972 0 17.708 0ZM18.5 17.708C18.5 18.145 18.145 18.5 17.708 18.5H2.292C1.855 18.5 1.5 18.145 1.5 17.708V4.418C1.5 3.981 1.854 3.628 2.29 3.626H17.71C18.146 3.626 18.5 3.981 18.5 4.416V17.71V17.708Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.032 8.035C5.74169 8.035 6.317 7.45968 6.317 6.75C6.317 6.04031 5.74169 5.465 5.032 5.465C4.32231 5.465 3.747 6.04031 3.747 6.75C3.747 7.45968 4.32231 8.035 5.032 8.035Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.032 12.441C5.74169 12.441 6.317 11.8657 6.317 11.156C6.317 10.4463 5.74169 9.871 5.032 9.871C4.32231 9.871 3.747 10.4463 3.747 11.156C3.747 11.8657 4.32231 12.441 5.032 12.441Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.968 8.035C15.6777 8.035 16.253 7.45968 16.253 6.75C16.253 6.04031 15.6777 5.465 14.968 5.465C14.2583 5.465 13.683 6.04031 13.683 6.75C13.683 7.45968 14.2583 8.035 14.968 8.035Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.968 12.441C15.6777 12.441 16.253 11.8657 16.253 11.156C16.253 10.4463 15.6777 9.871 14.968 9.871C14.2583 9.871 13.683 10.4463 13.683 11.156C13.683 11.8657 14.2583 12.441 14.968 12.441Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10 8.035C10.7097 8.035 11.285 7.45968 11.285 6.75C11.285 6.04031 10.7097 5.465 10 5.465C9.29031 5.465 8.715 6.04031 8.715 6.75C8.715 7.45968 9.29031 8.035 10 8.035Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10 12.441C10.7097 12.441 11.285 11.8657 11.285 11.156C11.285 10.4463 10.7097 9.871 10 9.871C9.29031 9.871 8.715 10.4463 8.715 11.156C8.715 11.8657 9.29031 12.441 10 12.441Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.032 16.771C5.74169 16.771 6.317 16.1957 6.317 15.486C6.317 14.7763 5.74169 14.201 5.032 14.201C4.32231 14.201 3.747 14.7763 3.747 15.486C3.747 16.1957 4.32231 16.771 5.032 16.771Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M10 16.771C10.7097 16.771 11.285 16.1957 11.285 15.486C11.285 14.7763 10.7097 14.201 10 14.201C9.29031 14.201 8.715 14.7763 8.715 15.486C8.715 16.1957 9.29031 16.771 10 16.771Z"
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.476433a4.svg";
export { ForwardRef as ReactComponent };